import { MultiplierByAlignmentLevel, SdgAlignmentLevel } from './types';

/**
 * In calculating total (mis)alignment of a company towards and SDG and valence
 * Revenue in each alignment level is considered only partially, by weighting it with the alignment level multiplier.
 *
 * Similarly, in deciding a single (mis)alignment level for parent products and mixins,
 * the market size of weakly and moderately (mis)aligned leaf product is considered only partially.
 *
 * See methodology docs: https://docs.uprightplatform.com/methodology/sdg-alignment
 */
export const alignmentLevelMultipliers: MultiplierByAlignmentLevel = {
  [SdgAlignmentLevel.STRONGLY_ALIGNED]: 1,
  [SdgAlignmentLevel.STRONGLY_MISALIGNED]: 1,
  [SdgAlignmentLevel.ALIGNED]: 0.5, // moderate
  [SdgAlignmentLevel.MISALIGNED]: 0.5, // moderate
  [SdgAlignmentLevel.WEAKLY_ALIGNED]: 0.25,
  [SdgAlignmentLevel.WEAKLY_MISALIGNED]: 0.25,
};

export function revertAlignmentLevelMultiplier(value: number, alignmentLevel: SdgAlignmentLevel) {
  return value / alignmentLevelMultipliers[alignmentLevel];
}
